import React from "react";

import NBAitem from "../../CollapseComponents/NBAitem";

// Define the TaskChoice interface to match what's used in Collapsible
interface TaskChoice {
    id: string | number;
    value: string;
}

// Define the recommendation interface based on usage in the component
interface Recommendation {
    task_id: string;
    description: string;
    read: boolean;
    task_choice?: TaskChoice[];
    // Using index signature for additional properties that might exist
    [key: string]:
        | string
        | number
        | boolean
        | null
        | undefined
        | object
        | TaskChoice[];
}

// Define the props interface for the List component
interface ListProps {
    recommendation: Recommendation;
    // eslint-disable-next-line no-unused-vars
    getRecommendations: (userId: string, clientId: string) => Promise<void>;
    client_id: string;
    userId: string | number;
}

const NBAlist: React.FC<ListProps> = ({
    recommendation,
    getRecommendations,
    client_id,
    userId,
}) => {
    return (
        recommendation && (
            <div className="w-full">
                <li className="text-sm mb-1 w-full">
                    <NBAitem
                        item={recommendation}
                        text={recommendation.description}
                        read={recommendation.read}
                        task_choices={recommendation.task_choice}
                        getRecommendations={getRecommendations}
                        client_id={client_id}
                        userId={userId}
                    />
                </li>
            </div>
        )
    );
};

export default NBAlist;
